// extracted by mini-css-extract-plugin
export default {"customPaddingTop":"UserManagement-module--customPaddingTop--H-GNi"};